import { render, staticRenderFns } from "./AccountWorkflowPage.vue?vue&type=template&id=4782d569&scoped=true"
import script from "./AccountWorkflowPage.vue?vue&type=script&lang=js"
export * from "./AccountWorkflowPage.vue?vue&type=script&lang=js"
import style0 from "./AccountWorkflowPage.vue?vue&type=style&index=0&id=4782d569&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4782d569",
  null
  
)

export default component.exports